import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Navbar from "./components/Navbar/Navbar"
import Footer from "./components/Footer/Footer"
import FloatingContact from "./components/FloatingContact/FloatingContact"
import Home from "./pages/Home/Home"
import Products from "./pages/Products/Products"
import ProductDetails from "./pages/ProductDetails/ProductDetails"
import Hose from "./pages/Hose/Hose"
import About from "./pages/About/About"
import Contact from "./pages/Contact/Contact"
import Company from "./pages/Company/Company"
import Market from "./pages/Market/Market"
import OurReach from "./pages/OurReach/OurReach"
import Technology from "./pages/Technology/Technology"
import Insights from "./pages/Insights/Insights"
import AdminDashboard from "./pages/Admin/AdminDashboard"
import AdminLogin from "./pages/Admin/AdminLogin"
import News from "./pages/news/News"
import NewsDetail from "./pages/newsDetails/NewsDetail"
import "./App.css"
import MarketProducts from "./pages/market-products/market-products"
import AutomobileProducts from "./pages/AutomobileProducts/AutomobileProducts"
import ProtectedRoute from "./components/ProtectedRoute";
import { HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useEffect } from "react"

// Create a separate component for scroll to top functionality
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:id" element={<ProductDetails />} />
              <Route path="/hoses" element={<Hose />} />
              <Route path="/about" element={<About />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/company" element={<Company />} />
              <Route path="/market" element={<Market />} />
              <Route path="/market/products" element={<MarketProducts />} />
              <Route path="/our-reach" element={<OurReach />} />
              <Route path="/technology" element={<Technology />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="automobile-products" element={<AutomobileProducts />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute> <AdminDashboard /> </ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
          <FloatingContact />
        </div>
      </Router>
    </HelmetProvider>
  )
}

export default App